import * as Yup from "yup";

export const Schema = Yup.object().shape({
    title: Yup.string().required("فیلد عنوان الزامی می باشد"),
    brief: Yup.string().required("فیلد توضیح کوتاه الزامی می باشد"),
    url: Yup.string().required("فیلد آدرس الزامی می باشد"),
});
